import type { Error } from '../types';

export const greaterThan = (compareTo: number, message?: Error['message']) => (value: number) => ({
  valid: value > compareTo,
  message
});
